import { MutationHookOptions, useMutation } from '@apollo/client';
import { CREATE_TAG } from '@frontend/app/queries';
import { CreateTag, CreateTagVariables } from '@frontend/app/queries/types/CreateTag';

type IOptions = MutationHookOptions<CreateTag, CreateTagVariables>;

export const useCreateTag = (options: IOptions = {}) => useMutation<CreateTag, CreateTagVariables>(CREATE_TAG, options);
